// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-XBoyxfuz clearfix","list":"list-1i2NSlLg"};